import { UsersPageThemeModeConfig } from './types';

const dark: UsersPageThemeModeConfig = {
  usersPage: {},
};

export default dark;
